import React from 'react';
import SelectLocations from '../../stepperBody/stepperBodyComponents/SelectLocations';
import AgreeToTerms from '../../stepperBody/stepperBodyComponents/AgreeToTerms';
import ReviewSubscription from '../../stepperBody/stepperBodyComponents/ReviewSubscription';

export const bodyConfig = {
  1: <SelectLocations />,
  2: <AgreeToTerms />,
  3: <ReviewSubscription />
};
